import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Stack,
  IconButton,
  useTheme,
} from "@mui/material";
import { useForm, SubmitHandler } from "react-hook-form";
import { FormProvider, RHFTextField } from "@app/components";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@app/redux/root-reducer";
import { addStatus, addValuation } from "../slice";
import { useLocation, useNavigate } from "react-router-dom";

interface IValuationForm {
  valuation: string;
}

export const CarValuationModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { requestId } = location.state as { requestId: number };
  
  const methods = useForm<IValuationForm>({
    defaultValues: {
      valuation: "",
    },
  });

  const { handleSubmit, reset } = methods;

  useEffect(() => {
    if (open) {
      reset({ valuation: "" });
    }
  }, [open, reset]);

  const onSubmit: SubmitHandler<IValuationForm> = (data) => {
    
    if (!requestId) {
      console.error("No request ID found!");
      return;
    }

    dispatch(
      addValuation({
        id: requestId,
        valuation: data.valuation, 
      })
    );

    setOpen(false);
    navigate(-1);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };

  // Auto open modal when component mounts
  useEffect(() => {
    if (requestId) {
      handleOpen();
    }
  }, [requestId]);

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            Add Car Valuation
            <IconButton onClick={handleClose} sx={{ p: 0 }}>
              <Icon icon="mdi:close" />
            </IconButton>
          </Stack>
        </DialogTitle>

        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Enter car valuation amount for request ID: {requestId}
          </DialogContentText>
          <RHFTextField 
            name="valuation" 
            label="Valuation Amount" 
            type="number"
            placeholder="Enter amount"
            fullWidth
            InputProps={{
              startAdornment: <span style={{ marginRight: '8px' }}>₹</span>,
            }}
          />
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 1, gap: 1.5 }}>
          <Button variant="outlined" onClick={handleClose} sx={{ flex: 1 }}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" sx={{ flex: 1 }}>
            Save
          </Button>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};